// Get the current item that was clicked and show the variants container
function showQuickAddVariants(button, variantId) {
  const card = button.parentNode;
  const variants = card.querySelector("#quickAddVariants");

  if (variantId) {
    // For single variant products, add directly to cart
    const form = button.closest('form');
    if (form) {
      // Prevent default submission
      event.preventDefault();
      
      // Show loading spinner if exists
      const loadingSpinner = button.querySelector('.loading-overlay__spinner');
      if (loadingSpinner) loadingSpinner.classList.remove('hidden');
      
      // Create form data and add to cart via AJAX
      const formData = new FormData(form);
      
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => response.json())
      .then(data => {
        // Track analytics
        sendUpsellEventToGA4(variantId);
        
        // Fetch updated cart sections
        if (window.cartNotification) {
          const sections = window.cartNotification.getSectionsToRender().map(s => s.section).join(',');
          
          return fetch(`${window.location.pathname}?sections=${sections}`)
            .then(response => response.json())
            .then(sections => {
              // Get current cart data
              return fetch('/cart.js')
                .then(res => res.json())
                .then(cart => {
                  // Prepare cart state for rendering
                  const parsedState = {
                    item_count: cart.item_count,
                    total_price: cart.total_price,
                    sections: sections
                  };
                  
                  // Render cart contents and show drawer
                  window.cartNotification.renderContents(parsedState);
                  
                  // Enable scroll prevention if function exists
                  if (typeof cartPreventScroll === 'function') {
                    cartPreventScroll();
                  }
                });
            });
        }
      })
      .catch(error => {
        console.error('Error adding product to cart:', error);
      })
      .finally(() => {
        // Hide loading spinner
        if (loadingSpinner) loadingSpinner.classList.add('hidden');
      });
    }
    return;
  }

  if (!variants) {
    return;
  }

  if (variants.style.display === "none") {
    variants.style.display = "block";
  } else {
    variants.style.display = "none";
  }
}

// Close the current item variant container
function closeQuickAddVariants(closeButton) {
  // Calls parentNode three times as the child is nested three times.
  const parent = closeButton.parentNode.parentNode.parentNode;
  parent.style.display = "none";
}

// Handle variant add to cart via AJAX
function variantAdded(variant, variantId) {
  // Get the form element containing the button
  const form = variant.closest('form');
  if (form) {
    // Prevent default form submission
    event.preventDefault();
    
    // Show loading spinner if present
    const loadingSpinner = variant.querySelector('.loading-overlay__spinner');
    if (loadingSpinner) loadingSpinner.classList.remove('hidden');
    
    // Create form data
    const formData = new FormData(form);
    
    // Send AJAX request to add to cart
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.json())
    .then(data => {
      // Close the variant drawer
      setTimeout(() => {
        const parent = variant.closest(".variant-drawer");
        if (parent) parent.style.display = "none";
      }, 300);
      
      // Track analytics
      sendUpsellEventToGA4(variantId);
      
      // Update and show cart notification
      if (window.cartNotification) {
        const sections = window.cartNotification.getSectionsToRender().map(s => s.section).join(',');
        
        return fetch(`${window.location.pathname}?sections=${sections}`)
          .then(response => response.json())
          .then(sections => {
            return fetch('/cart.js')
              .then(res => res.json())
              .then(cart => {
                const parsedState = {
                  item_count: cart.item_count,
                  total_price: cart.total_price,
                  sections: sections
                };
                
                window.cartNotification.renderContents(parsedState);
                
                if (typeof cartPreventScroll === 'function') {
                  cartPreventScroll();
                }
              });
          });
      }
    })
    .catch(error => {
      console.error('Error adding product to cart:', error);
    })
    .finally(() => {
      // Hide loading spinner
      if (loadingSpinner) loadingSpinner.classList.add('hidden');
    });
  } else {
    // Fallback if form not found
    setTimeout(() => {
      const parent = variant.closest(".variant-drawer");
      if (parent) parent.style.display = "none";
    }, 300);
    
    sendUpsellEventToGA4(variantId);
  }
}

function sendUpsellEventToGA4(variantId) {
  sendUpsellAddToCartToGA4();
  getGa4Object(variantId)
    .then((ga4Object) => {
      const variantId = ga4Object._variantId;
      delete ga4Object._variantId;
      ga4Object.value = ga4Object.price;
      ga4Object.quantity = 1;
      sessionStorage.setItem(variantId, JSON.stringify(ga4Object));
      Shopify.analytics.publish('quick_add_to_cart', ga4Object);
    })
    .catch(() => {
      console.error(
        "Cannot push object for quick add to cart event. No object found for the event"
      );
    });
}